var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 184,
    viewBox: "0 0 222 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 0L6.30714 3.34504L9.65217 4.82609L6.30714 6.30714L4.82609 9.65217L3.34504 6.30714L0 4.82609L3.34504 3.34504L4.82609 0Z",
    fill: "url(#paint0_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 19.3042L6.30714 22.6492L9.65217 24.1303L6.30714 25.6113L4.82609 28.9564L3.34504 25.6113L0 24.1303L3.34504 22.6492L4.82609 19.3042Z",
    fill: "url(#paint1_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 38.6089L6.30714 41.9539L9.65217 43.435L6.30714 44.916L4.82609 48.2611L3.34504 44.916L0 43.435L3.34504 41.9539L4.82609 38.6089Z",
    fill: "url(#paint2_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 57.9131L6.30714 61.2581L9.65217 62.7392L6.30714 64.2202L4.82609 67.5653L3.34504 64.2202L0 62.7392L3.34504 61.2581L4.82609 57.9131Z",
    fill: "url(#paint3_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 77.2173L6.30714 80.5623L9.65217 82.0434L6.30714 83.5244L4.82609 86.8695L3.34504 83.5244L0 82.0434L3.34504 80.5623L4.82609 77.2173Z",
    fill: "url(#paint4_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 96.5215L6.30714 99.8665L9.65217 101.348L6.30714 102.829L4.82609 106.174L3.34504 102.829L0 101.348L3.34504 99.8665L4.82609 96.5215Z",
    fill: "url(#paint5_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 115.826L6.30714 119.171L9.65217 120.653L6.30714 122.134L4.82609 125.479L3.34504 122.134L0 120.653L3.34504 119.171L4.82609 115.826Z",
    fill: "url(#paint6_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 135.131L6.30714 138.476L9.65217 139.957L6.30714 141.438L4.82609 144.783L3.34504 141.438L0 139.957L3.34504 138.476L4.82609 135.131Z",
    fill: "url(#paint7_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 154.435L6.30714 157.78L9.65217 159.261L6.30714 160.742L4.82609 164.087L3.34504 160.742L0 159.261L3.34504 157.78L4.82609 154.435Z",
    fill: "url(#paint8_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82609 173.739L6.30714 177.084L9.65217 178.565L6.30714 180.046L4.82609 183.391L3.34504 180.046L0 178.565L3.34504 177.084L4.82609 173.739Z",
    fill: "url(#paint9_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 0L25.6108 3.34504L28.9559 4.82609L25.6108 6.30714L24.1298 9.65217L22.6487 6.30714L19.3037 4.82609L22.6487 3.34504L24.1298 0Z",
    fill: "url(#paint10_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 19.3042L25.6108 22.6492L28.9559 24.1303L25.6108 25.6113L24.1298 28.9564L22.6487 25.6113L19.3037 24.1303L22.6487 22.6492L24.1298 19.3042Z",
    fill: "url(#paint11_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 38.6089L25.6108 41.9539L28.9559 43.435L25.6108 44.916L24.1298 48.2611L22.6487 44.916L19.3037 43.435L22.6487 41.9539L24.1298 38.6089Z",
    fill: "url(#paint12_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 57.9131L25.6108 61.2581L28.9559 62.7392L25.6108 64.2202L24.1298 67.5653L22.6487 64.2202L19.3037 62.7392L22.6487 61.2581L24.1298 57.9131Z",
    fill: "url(#paint13_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 77.2173L25.6108 80.5623L28.9559 82.0434L25.6108 83.5244L24.1298 86.8695L22.6487 83.5244L19.3037 82.0434L22.6487 80.5623L24.1298 77.2173Z",
    fill: "url(#paint14_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 96.5215L25.6108 99.8665L28.9559 101.348L25.6108 102.829L24.1298 106.174L22.6487 102.829L19.3037 101.348L22.6487 99.8665L24.1298 96.5215Z",
    fill: "url(#paint15_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 115.826L25.6108 119.171L28.9559 120.653L25.6108 122.134L24.1298 125.479L22.6487 122.134L19.3037 120.653L22.6487 119.171L24.1298 115.826Z",
    fill: "url(#paint16_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 135.131L25.6108 138.476L28.9559 139.957L25.6108 141.438L24.1298 144.783L22.6487 141.438L19.3037 139.957L22.6487 138.476L24.1298 135.131Z",
    fill: "url(#paint17_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 154.435L25.6108 157.78L28.9559 159.261L25.6108 160.742L24.1298 164.087L22.6487 160.742L19.3037 159.261L22.6487 157.78L24.1298 154.435Z",
    fill: "url(#paint18_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 173.739L25.6108 177.084L28.9559 178.565L25.6108 180.046L24.1298 183.391L22.6487 180.046L19.3037 178.565L22.6487 177.084L24.1298 173.739Z",
    fill: "url(#paint19_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 0L44.9165 3.34504L48.2615 4.82609L44.9165 6.30714L43.4355 9.65217L41.9544 6.30714L38.6094 4.82609L41.9544 3.34504L43.4355 0Z",
    fill: "url(#paint20_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 19.3042L44.9165 22.6492L48.2615 24.1303L44.9165 25.6113L43.4355 28.9564L41.9544 25.6113L38.6094 24.1303L41.9544 22.6492L43.4355 19.3042Z",
    fill: "url(#paint21_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 38.6089L44.9165 41.9539L48.2615 43.435L44.9165 44.916L43.4355 48.2611L41.9544 44.916L38.6094 43.435L41.9544 41.9539L43.4355 38.6089Z",
    fill: "url(#paint22_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 57.9131L44.9165 61.2581L48.2615 62.7392L44.9165 64.2202L43.4355 67.5653L41.9544 64.2202L38.6094 62.7392L41.9544 61.2581L43.4355 57.9131Z",
    fill: "url(#paint23_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 77.2173L44.9165 80.5623L48.2615 82.0434L44.9165 83.5244L43.4355 86.8695L41.9544 83.5244L38.6094 82.0434L41.9544 80.5623L43.4355 77.2173Z",
    fill: "url(#paint24_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 96.5215L44.9165 99.8665L48.2615 101.348L44.9165 102.829L43.4355 106.174L41.9544 102.829L38.6094 101.348L41.9544 99.8665L43.4355 96.5215Z",
    fill: "url(#paint25_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 115.826L44.9165 119.171L48.2615 120.653L44.9165 122.134L43.4355 125.479L41.9544 122.134L38.6094 120.653L41.9544 119.171L43.4355 115.826Z",
    fill: "url(#paint26_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 135.131L44.9165 138.476L48.2615 139.957L44.9165 141.438L43.4355 144.783L41.9544 141.438L38.6094 139.957L41.9544 138.476L43.4355 135.131Z",
    fill: "url(#paint27_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 154.435L44.9165 157.78L48.2615 159.261L44.9165 160.742L43.4355 164.087L41.9544 160.742L38.6094 159.261L41.9544 157.78L43.4355 154.435Z",
    fill: "url(#paint28_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 173.739L44.9165 177.084L48.2615 178.565L44.9165 180.046L43.4355 183.391L41.9544 180.046L38.6094 178.565L41.9544 177.084L43.4355 173.739Z",
    fill: "url(#paint29_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 0L64.2202 3.34504L67.5653 4.82609L64.2202 6.30714L62.7392 9.65217L61.2581 6.30714L57.9131 4.82609L61.2581 3.34504L62.7392 0Z",
    fill: "url(#paint30_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 19.3042L64.2202 22.6492L67.5653 24.1303L64.2202 25.6113L62.7392 28.9564L61.2581 25.6113L57.9131 24.1303L61.2581 22.6492L62.7392 19.3042Z",
    fill: "url(#paint31_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 38.6089L64.2202 41.9539L67.5653 43.435L64.2202 44.916L62.7392 48.2611L61.2581 44.916L57.9131 43.435L61.2581 41.9539L62.7392 38.6089Z",
    fill: "url(#paint32_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 57.9131L64.2202 61.2581L67.5653 62.7392L64.2202 64.2202L62.7392 67.5653L61.2581 64.2202L57.9131 62.7392L61.2581 61.2581L62.7392 57.9131Z",
    fill: "url(#paint33_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 77.2173L64.2202 80.5623L67.5653 82.0434L64.2202 83.5244L62.7392 86.8695L61.2581 83.5244L57.9131 82.0434L61.2581 80.5623L62.7392 77.2173Z",
    fill: "url(#paint34_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 96.5215L64.2202 99.8665L67.5653 101.348L64.2202 102.829L62.7392 106.174L61.2581 102.829L57.9131 101.348L61.2581 99.8665L62.7392 96.5215Z",
    fill: "url(#paint35_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 115.826L64.2202 119.171L67.5653 120.653L64.2202 122.134L62.7392 125.479L61.2581 122.134L57.9131 120.653L61.2581 119.171L62.7392 115.826Z",
    fill: "url(#paint36_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 135.131L64.2202 138.476L67.5653 139.957L64.2202 141.438L62.7392 144.783L61.2581 141.438L57.9131 139.957L61.2581 138.476L62.7392 135.131Z",
    fill: "url(#paint37_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 154.435L64.2202 157.78L67.5653 159.261L64.2202 160.742L62.7392 164.087L61.2581 160.742L57.9131 159.261L61.2581 157.78L62.7392 154.435Z",
    fill: "url(#paint38_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7392 173.739L64.2202 177.084L67.5653 178.565L64.2202 180.046L62.7392 183.391L61.2581 180.046L57.9131 178.565L61.2581 177.084L62.7392 173.739Z",
    fill: "url(#paint39_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 0L83.5249 3.34504L86.8699 4.82609L83.5249 6.30714L82.0439 9.65217L80.5628 6.30714L77.2178 4.82609L80.5628 3.34504L82.0439 0Z",
    fill: "url(#paint40_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 19.3042L83.5249 22.6492L86.8699 24.1303L83.5249 25.6113L82.0439 28.9564L80.5628 25.6113L77.2178 24.1303L80.5628 22.6492L82.0439 19.3042Z",
    fill: "url(#paint41_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 38.6089L83.5249 41.9539L86.8699 43.435L83.5249 44.916L82.0439 48.2611L80.5628 44.916L77.2178 43.435L80.5628 41.9539L82.0439 38.6089Z",
    fill: "url(#paint42_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 57.9131L83.5249 61.2581L86.8699 62.7392L83.5249 64.2202L82.0439 67.5653L80.5628 64.2202L77.2178 62.7392L80.5628 61.2581L82.0439 57.9131Z",
    fill: "url(#paint43_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 77.2173L83.5249 80.5623L86.8699 82.0434L83.5249 83.5244L82.0439 86.8695L80.5628 83.5244L77.2178 82.0434L80.5628 80.5623L82.0439 77.2173Z",
    fill: "url(#paint44_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 96.5215L83.5249 99.8665L86.8699 101.348L83.5249 102.829L82.0439 106.174L80.5628 102.829L77.2178 101.348L80.5628 99.8665L82.0439 96.5215Z",
    fill: "url(#paint45_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 115.826L83.5249 119.171L86.8699 120.653L83.5249 122.134L82.0439 125.479L80.5628 122.134L77.2178 120.653L80.5628 119.171L82.0439 115.826Z",
    fill: "url(#paint46_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 135.131L83.5249 138.476L86.8699 139.957L83.5249 141.438L82.0439 144.783L80.5628 141.438L77.2178 139.957L80.5628 138.476L82.0439 135.131Z",
    fill: "url(#paint47_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 154.435L83.5249 157.78L86.8699 159.261L83.5249 160.742L82.0439 164.087L80.5628 160.742L77.2178 159.261L80.5628 157.78L82.0439 154.435Z",
    fill: "url(#paint48_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0439 173.739L83.5249 177.084L86.8699 178.565L83.5249 180.046L82.0439 183.391L80.5628 180.046L77.2178 178.565L80.5628 177.084L82.0439 173.739Z",
    fill: "url(#paint49_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 0L102.829 3.34504L106.174 4.82609L102.829 6.30714L101.348 9.65217L99.8665 6.30714L96.5215 4.82609L99.8665 3.34504L101.348 0Z",
    fill: "url(#paint50_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 19.3042L102.829 22.6492L106.174 24.1303L102.829 25.6113L101.348 28.9564L99.8665 25.6113L96.5215 24.1303L99.8665 22.6492L101.348 19.3042Z",
    fill: "url(#paint51_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 38.6089L102.829 41.9539L106.174 43.435L102.829 44.916L101.348 48.2611L99.8665 44.916L96.5215 43.435L99.8665 41.9539L101.348 38.6089Z",
    fill: "url(#paint52_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 57.9131L102.829 61.2581L106.174 62.7392L102.829 64.2202L101.348 67.5653L99.8665 64.2202L96.5215 62.7392L99.8665 61.2581L101.348 57.9131Z",
    fill: "url(#paint53_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 77.2173L102.829 80.5623L106.174 82.0434L102.829 83.5244L101.348 86.8695L99.8665 83.5244L96.5215 82.0434L99.8665 80.5623L101.348 77.2173Z",
    fill: "url(#paint54_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 96.5215L102.829 99.8665L106.174 101.348L102.829 102.829L101.348 106.174L99.8665 102.829L96.5215 101.348L99.8665 99.8665L101.348 96.5215Z",
    fill: "url(#paint55_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 115.826L102.829 119.171L106.174 120.653L102.829 122.134L101.348 125.479L99.8665 122.134L96.5215 120.653L99.8665 119.171L101.348 115.826Z",
    fill: "url(#paint56_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 135.131L102.829 138.476L106.174 139.957L102.829 141.438L101.348 144.783L99.8665 141.438L96.5215 139.957L99.8665 138.476L101.348 135.131Z",
    fill: "url(#paint57_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 154.435L102.829 157.78L106.174 159.261L102.829 160.742L101.348 164.087L99.8665 160.742L96.5215 159.261L99.8665 157.78L101.348 154.435Z",
    fill: "url(#paint58_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348 173.739L102.829 177.084L106.174 178.565L102.829 180.046L101.348 183.391L99.8665 180.046L96.5215 178.565L99.8665 177.084L101.348 173.739Z",
    fill: "url(#paint59_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 0L122.133 3.34504L125.478 4.82609L122.133 6.30714L120.652 9.65217L119.171 6.30714L115.826 4.82609L119.171 3.34504L120.652 0Z",
    fill: "url(#paint60_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 19.3042L122.133 22.6492L125.478 24.1303L122.133 25.6113L120.652 28.9564L119.171 25.6113L115.826 24.1303L119.171 22.6492L120.652 19.3042Z",
    fill: "url(#paint61_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 38.6089L122.133 41.9539L125.478 43.435L122.133 44.916L120.652 48.2611L119.171 44.916L115.826 43.435L119.171 41.9539L120.652 38.6089Z",
    fill: "url(#paint62_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 57.9131L122.133 61.2581L125.478 62.7392L122.133 64.2202L120.652 67.5653L119.171 64.2202L115.826 62.7392L119.171 61.2581L120.652 57.9131Z",
    fill: "url(#paint63_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 77.2173L122.133 80.5623L125.478 82.0434L122.133 83.5244L120.652 86.8695L119.171 83.5244L115.826 82.0434L119.171 80.5623L120.652 77.2173Z",
    fill: "url(#paint64_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 96.5215L122.133 99.8665L125.478 101.348L122.133 102.829L120.652 106.174L119.171 102.829L115.826 101.348L119.171 99.8665L120.652 96.5215Z",
    fill: "url(#paint65_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 115.826L122.133 119.171L125.478 120.653L122.133 122.134L120.652 125.479L119.171 122.134L115.826 120.653L119.171 119.171L120.652 115.826Z",
    fill: "url(#paint66_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 135.131L122.133 138.476L125.478 139.957L122.133 141.438L120.652 144.783L119.171 141.438L115.826 139.957L119.171 138.476L120.652 135.131Z",
    fill: "url(#paint67_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 154.435L122.133 157.78L125.478 159.261L122.133 160.742L120.652 164.087L119.171 160.742L115.826 159.261L119.171 157.78L120.652 154.435Z",
    fill: "url(#paint68_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.652 173.739L122.133 177.084L125.478 178.565L122.133 180.046L120.652 183.391L119.171 180.046L115.826 178.565L119.171 177.084L120.652 173.739Z",
    fill: "url(#paint69_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 0L141.438 3.34504L144.783 4.82609L141.438 6.30714L139.957 9.65217L138.476 6.30714L135.131 4.82609L138.476 3.34504L139.957 0Z",
    fill: "url(#paint70_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 19.3042L141.438 22.6492L144.783 24.1303L141.438 25.6113L139.957 28.9564L138.476 25.6113L135.131 24.1303L138.476 22.6492L139.957 19.3042Z",
    fill: "url(#paint71_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 38.6089L141.438 41.9539L144.783 43.435L141.438 44.916L139.957 48.2611L138.476 44.916L135.131 43.435L138.476 41.9539L139.957 38.6089Z",
    fill: "url(#paint72_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 57.9131L141.438 61.2581L144.783 62.7392L141.438 64.2202L139.957 67.5653L138.476 64.2202L135.131 62.7392L138.476 61.2581L139.957 57.9131Z",
    fill: "url(#paint73_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 77.2173L141.438 80.5623L144.783 82.0434L141.438 83.5244L139.957 86.8695L138.476 83.5244L135.131 82.0434L138.476 80.5623L139.957 77.2173Z",
    fill: "url(#paint74_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 96.5215L141.438 99.8665L144.783 101.348L141.438 102.829L139.957 106.174L138.476 102.829L135.131 101.348L138.476 99.8665L139.957 96.5215Z",
    fill: "url(#paint75_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 115.826L141.438 119.171L144.783 120.653L141.438 122.134L139.957 125.479L138.476 122.134L135.131 120.653L138.476 119.171L139.957 115.826Z",
    fill: "url(#paint76_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 135.131L141.438 138.476L144.783 139.957L141.438 141.438L139.957 144.783L138.476 141.438L135.131 139.957L138.476 138.476L139.957 135.131Z",
    fill: "url(#paint77_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 154.435L141.438 157.78L144.783 159.261L141.438 160.742L139.957 164.087L138.476 160.742L135.131 159.261L138.476 157.78L139.957 154.435Z",
    fill: "url(#paint78_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.957 173.739L141.438 177.084L144.783 178.565L141.438 180.046L139.957 183.391L138.476 180.046L135.131 178.565L138.476 177.084L139.957 173.739Z",
    fill: "url(#paint79_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 0L160.742 3.34504L164.087 4.82609L160.742 6.30714L159.261 9.65217L157.78 6.30714L154.435 4.82609L157.78 3.34504L159.261 0Z",
    fill: "url(#paint80_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 19.3042L160.742 22.6492L164.087 24.1303L160.742 25.6113L159.261 28.9564L157.78 25.6113L154.435 24.1303L157.78 22.6492L159.261 19.3042Z",
    fill: "url(#paint81_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 38.6089L160.742 41.9539L164.087 43.435L160.742 44.916L159.261 48.2611L157.78 44.916L154.435 43.435L157.78 41.9539L159.261 38.6089Z",
    fill: "url(#paint82_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 57.9131L160.742 61.2581L164.087 62.7392L160.742 64.2202L159.261 67.5653L157.78 64.2202L154.435 62.7392L157.78 61.2581L159.261 57.9131Z",
    fill: "url(#paint83_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 77.2173L160.742 80.5623L164.087 82.0434L160.742 83.5244L159.261 86.8695L157.78 83.5244L154.435 82.0434L157.78 80.5623L159.261 77.2173Z",
    fill: "url(#paint84_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 96.5215L160.742 99.8665L164.087 101.348L160.742 102.829L159.261 106.174L157.78 102.829L154.435 101.348L157.78 99.8665L159.261 96.5215Z",
    fill: "url(#paint85_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 115.826L160.742 119.171L164.087 120.653L160.742 122.134L159.261 125.479L157.78 122.134L154.435 120.653L157.78 119.171L159.261 115.826Z",
    fill: "url(#paint86_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 135.131L160.742 138.476L164.087 139.957L160.742 141.438L159.261 144.783L157.78 141.438L154.435 139.957L157.78 138.476L159.261 135.131Z",
    fill: "url(#paint87_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 154.435L160.742 157.78L164.087 159.261L160.742 160.742L159.261 164.087L157.78 160.742L154.435 159.261L157.78 157.78L159.261 154.435Z",
    fill: "url(#paint88_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 173.739L160.742 177.084L164.087 178.565L160.742 180.046L159.261 183.391L157.78 180.046L154.435 178.565L157.78 177.084L159.261 173.739Z",
    fill: "url(#paint89_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 0L180.046 3.34504L183.391 4.82609L180.046 6.30714L178.565 9.65217L177.084 6.30714L173.739 4.82609L177.084 3.34504L178.565 0Z",
    fill: "url(#paint90_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 19.3042L180.046 22.6492L183.391 24.1303L180.046 25.6113L178.565 28.9564L177.084 25.6113L173.739 24.1303L177.084 22.6492L178.565 19.3042Z",
    fill: "url(#paint91_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 38.6089L180.046 41.9539L183.391 43.435L180.046 44.916L178.565 48.2611L177.084 44.916L173.739 43.435L177.084 41.9539L178.565 38.6089Z",
    fill: "url(#paint92_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 57.9131L180.046 61.2581L183.391 62.7392L180.046 64.2202L178.565 67.5653L177.084 64.2202L173.739 62.7392L177.084 61.2581L178.565 57.9131Z",
    fill: "url(#paint93_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 77.2173L180.046 80.5623L183.391 82.0434L180.046 83.5244L178.565 86.8695L177.084 83.5244L173.739 82.0434L177.084 80.5623L178.565 77.2173Z",
    fill: "url(#paint94_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 96.5215L180.046 99.8665L183.391 101.348L180.046 102.829L178.565 106.174L177.084 102.829L173.739 101.348L177.084 99.8665L178.565 96.5215Z",
    fill: "url(#paint95_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 115.826L180.046 119.171L183.391 120.653L180.046 122.134L178.565 125.479L177.084 122.134L173.739 120.653L177.084 119.171L178.565 115.826Z",
    fill: "url(#paint96_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 135.131L180.046 138.476L183.391 139.957L180.046 141.438L178.565 144.783L177.084 141.438L173.739 139.957L177.084 138.476L178.565 135.131Z",
    fill: "url(#paint97_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 154.435L180.046 157.78L183.391 159.261L180.046 160.742L178.565 164.087L177.084 160.742L173.739 159.261L177.084 157.78L178.565 154.435Z",
    fill: "url(#paint98_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 173.739L180.046 177.084L183.391 178.565L180.046 180.046L178.565 183.391L177.084 180.046L173.739 178.565L177.084 177.084L178.565 173.739Z",
    fill: "url(#paint99_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 0L199.35 3.34504L202.695 4.82609L199.35 6.30714L197.869 9.65217L196.388 6.30714L193.043 4.82609L196.388 3.34504L197.869 0Z",
    fill: "url(#paint100_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 19.3042L199.35 22.6492L202.695 24.1303L199.35 25.6113L197.869 28.9564L196.388 25.6113L193.043 24.1303L196.388 22.6492L197.869 19.3042Z",
    fill: "url(#paint101_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 38.6089L199.35 41.9539L202.695 43.435L199.35 44.916L197.869 48.2611L196.388 44.916L193.043 43.435L196.388 41.9539L197.869 38.6089Z",
    fill: "url(#paint102_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 57.9131L199.35 61.2581L202.695 62.7392L199.35 64.2202L197.869 67.5653L196.388 64.2202L193.043 62.7392L196.388 61.2581L197.869 57.9131Z",
    fill: "url(#paint103_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 77.2173L199.35 80.5623L202.695 82.0434L199.35 83.5244L197.869 86.8695L196.388 83.5244L193.043 82.0434L196.388 80.5623L197.869 77.2173Z",
    fill: "url(#paint104_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 96.5215L199.35 99.8665L202.695 101.348L199.35 102.829L197.869 106.174L196.388 102.829L193.043 101.348L196.388 99.8665L197.869 96.5215Z",
    fill: "url(#paint105_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 115.826L199.35 119.171L202.695 120.653L199.35 122.134L197.869 125.479L196.388 122.134L193.043 120.653L196.388 119.171L197.869 115.826Z",
    fill: "url(#paint106_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 135.131L199.35 138.476L202.695 139.957L199.35 141.438L197.869 144.783L196.388 141.438L193.043 139.957L196.388 138.476L197.869 135.131Z",
    fill: "url(#paint107_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 154.435L199.35 157.78L202.695 159.261L199.35 160.742L197.869 164.087L196.388 160.742L193.043 159.261L196.388 157.78L197.869 154.435Z",
    fill: "url(#paint108_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.869 173.739L199.35 177.084L202.695 178.565L199.35 180.046L197.869 183.391L196.388 180.046L193.043 178.565L196.388 177.084L197.869 173.739Z",
    fill: "url(#paint109_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 0L218.655 3.34504L222 4.82609L218.655 6.30714L217.174 9.65217L215.693 6.30714L212.348 4.82609L215.693 3.34504L217.174 0Z",
    fill: "url(#paint110_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 19.3042L218.655 22.6492L222 24.1303L218.655 25.6113L217.174 28.9564L215.693 25.6113L212.348 24.1303L215.693 22.6492L217.174 19.3042Z",
    fill: "url(#paint111_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 38.6089L218.655 41.9539L222 43.435L218.655 44.916L217.174 48.2611L215.693 44.916L212.348 43.435L215.693 41.9539L217.174 38.6089Z",
    fill: "url(#paint112_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 57.9131L218.655 61.2581L222 62.7392L218.655 64.2202L217.174 67.5653L215.693 64.2202L212.348 62.7392L215.693 61.2581L217.174 57.9131Z",
    fill: "url(#paint113_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 77.2173L218.655 80.5623L222 82.0434L218.655 83.5244L217.174 86.8695L215.693 83.5244L212.348 82.0434L215.693 80.5623L217.174 77.2173Z",
    fill: "url(#paint114_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 96.5215L218.655 99.8665L222 101.348L218.655 102.829L217.174 106.174L215.693 102.829L212.348 101.348L215.693 99.8665L217.174 96.5215Z",
    fill: "url(#paint115_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 115.826L218.655 119.171L222 120.653L218.655 122.134L217.174 125.479L215.693 122.134L212.348 120.653L215.693 119.171L217.174 115.826Z",
    fill: "url(#paint116_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 135.131L218.655 138.476L222 139.957L218.655 141.438L217.174 144.783L215.693 141.438L212.348 139.957L215.693 138.476L217.174 135.131Z",
    fill: "url(#paint117_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 154.435L218.655 157.78L222 159.261L218.655 160.742L217.174 164.087L215.693 160.742L212.348 159.261L215.693 157.78L217.174 154.435Z",
    fill: "url(#paint118_angular_2725_10950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174 173.739L218.655 177.084L222 178.565L218.655 180.046L217.174 183.391L215.693 180.046L212.348 178.565L215.693 177.084L217.174 173.739Z",
    fill: "url(#paint119_angular_2725_10950)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.82609 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1298 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4355 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7392 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0439 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.348 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.652 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.957 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.261 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.565 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.869 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 4.82609) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 24.1303) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 43.435) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 62.7392) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 82.0434) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 101.348) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 120.653) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 139.957) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 159.261) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_angular_2725_10950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.174 178.565) rotate(50.4403) scale(5.39036 6.40786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7379"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteBg);
export default __webpack_public_path__ + "static/media/invite-bg.987c569ede146bf6eae90d4702675f0c.svg";
export { ForwardRef as ReactComponent };